
import { onMounted, ref, reactive, computed, inject, watch, nextTick, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { nativeToast, nativeGoBack } from '@/utils/nativeFn'
import store from '@/store/index'
import { getQuestionList, saveAnswer } from '@/api/weeksStudy'
import NewActionBar from '@/components/NewActionBar.vue'
import QuestionDetail from '@/components/Aio/QuestionTile.vue'
import AioConfirm from '@/components/Aio/AioConfirm.vue'
import NewWrongPage from '@/components/NewWrongPage.vue'
import LoadingPage from './component/LoadingPage/index.vue'
import QuesAnalysis from './component/QuesAnalysis/index.vue'
import ExerciseReport from '@/views/Aio/ExerciseReport.vue'
import AnswerSheet from '@/components/Aio/AnswerSheet.vue'

export default {
  name: 'TaskPaper',
  components: {
    NewActionBar,
    QuestionDetail,
    AioConfirm,
    NewWrongPage,
    LoadingPage,
    ExerciseReport,
    AnswerSheet,
    QuesAnalysis
  },
  setup() {
    const loadingProgress = ref<number>(0)
    const pageLoading = computed(() => loadingProgress.value !== 100) // 页面加载中标识
    const $xesLog = inject('$xesLog') as any // 埋点
    const page_name = 'itembank'
    const showWrongPage = ref(false) // 是否展示接口失败页面
    let queResList = ref([])
    const unAnsweredNum = ref(0)
    const confirmVisible = ref(false)
    const confirmInfo = reactive({})
    let entryTime = 0 // 进入页面时间
    const retryNum = ref(-1)
    const {
      lkName,
      gradeGroupId = '',
      subjectId = '',
      catalogueId = '',
      lkId = '',
      lkcId = '',
      gradeId = ''
    } = useRoute().query || {}
    const paperConfiged = ref(false)
    const questionList = computed(() => store.getters['taskPaper/questionList'])
    const sumScore = ref(0) // 试卷总分数
    let answerMap = {} // 所有学生做答答案map key为题目id
    const judgeMap = {} // 所有判题结果map key为题目id
    let questionsMap = {} // 所有问题的map 用于判断
    const paperInfo = ref([]) // 所有题目信息
    const swipeBox = ref(null)
    const swipWrap = ref(null)
    const currentIndex = ref(0) // 当前正在展示的题目的index
    const actionBarInfo = reactive({
      actionBarTitle: decodeURI(lkName as string),
      actionBarBg: '#ffffff'
    })
    document.title = decodeURI(lkName as string)
    const showAnswerReport = ref(false)
    const answerSheetVisible = ref(false)
    const showAnswerAnalysis = ref(false)
    const submitQestionMap = ref({})
    const submitFlag = ref(false)
    const showButton = ref(false)
    watch(currentIndex, (value) => {
      if (value >= 4) {
        showButton.value = true
      }
    })

    const doClose = () => {
      confirmVisible.value = false
    }
    const doConfirm = () => nativeGoBack({}, () => {})
    const goBack = () => {
      // 如果是处于加载中或者展示失败。那么直接退出没有提示
      if (pageLoading || showWrongPage) {
        doConfirm()
      } else {
        Object.assign(confirmInfo, {
          title: '确认退出答题吗？',
          detail: `退出后不保留未提交的答题记录`,
          cancelText: '去意已决',
          confirmText: '继续做答',
          doClose: doConfirm,
          doConfirm: doClose
        })
        confirmVisible.value = true
      }
    }
    // const actionBarHeight = computed(() => store.getters.actionBarHeight)
    // 初始化questionsMap（以题目id为key）并计算总分数
    const initQuestionsMap = () => {
      let _questionsMap = {}
      let _sumScore = 0
      let _queResList = []
      paperInfo.value.forEach((item, index) => {
        _queResList[index] = {}
        if (item.logicQuesTypeId === '9' && item?.childList?.length) {
          // 复合题
          _queResList[index] = {
            isDecidable: 1,
            ansResList: [],
            queId: item.queId,
            index,
            childList: []
          }
          item.childList.forEach((tile, key) => {
            let { queId, logicQuesTypeId, score, isDecidable } = tile
            if (isDecidable !== 1) {
              _queResList[index].isDecidable = 0
              store.commit('taskPaper/SET_DATA', ['isAllDecidable', false])
            }
            _sumScore += score
            _questionsMap[queId] = {
              rootId: item.queId,
              queId: queId,
              index,
              subIndex: key,
              type: logicQuesTypeId,
              score,
              isDecidable,
              queData: tile
            }
            _queResList[index].childList.push(queId)
          })
        } else {
          let { queId, logicQuesTypeId, score, isDecidable } = item
          if (isDecidable !== 1) {
            store.commit('taskPaper/SET_DATA', ['isAllDecidable', false])
          }
          _sumScore += score
          _questionsMap[queId] = {
            rootId: queId,
            queId: queId,
            index,
            type: logicQuesTypeId,
            score,
            isDecidable,
            queData: item
          }
          _queResList[index] = {
            ansResList: [],
            queId: queId,
            isDecidable,
            index,
            childList: null
          }
        }
      })
      queResList.value = _queResList
      sumScore.value = _sumScore
      questionsMap = _questionsMap
    }
    const makeResult = (judgeRes) => {
      let _queResList = queResList.value.map((item) => ({ ...item, ansResList: [] })) // 清空ansResList防止影响再次作答
      judgeRes.forEach((item) => (judgeMap[item[0].queId] = item[0].judge))
      let _queSumScore = 0
      let _stuSumScore = 0
      let submitObj = {}
      Object.keys(questionsMap).forEach((item) => {
        let stuScore = 0
        let ansRes = 1 // 不能判题默认正确
        // 按填对的题数计算正确率
        let queScore = 0
        let { rootId, type, queId } = questionsMap[item]
        if (questionsMap[item].isDecidable === 1) {
          // 可判题
          let tmpLen = (judgeMap[item] || []).filter((tile) => tile === 1).length
          stuScore = tmpLen
          queScore = judgeMap?.[item].length
        } else {
          // 不可判题默认正确
          stuScore = answerMap[item]?.length || 1
          queScore = stuScore
        }
        if (stuScore === queScore) {
          ansRes = 1
        } else if ((stuScore && stuScore < queScore) || judgeMap[item]?.includes(3)) {
          ansRes = 3
        } else {
          ansRes = 0
        }
        if (
          (questionsMap?.[item]?.index || questionsMap?.[item]?.index === 0) &&
          _queResList?.[questionsMap?.[item]?.index]
        ) {
          _queResList[questionsMap[item].index].ansResList.push(ansRes)
        }
        submitObj[item] = {
          rootId,
          queId,
          queScore,
          type,
          stuScore,
          data: answerMap[item] || [''],
          judge: judgeMap[item] || [1],
          ansRes
        }
        _stuSumScore += stuScore
        _queSumScore += queScore
      })
      queResList.value = _queResList.map((item) => {
        let resSum = item.ansResList.reduce((pre, cur) => pre + (cur || 0), 0)
        return {
          ...item,
          ansResStatus: resSum === 0 ? 0 : resSum > 0 && resSum !== item.ansResList.length ? 2 : 1
        }
      })
      store.commit('taskPaper/SET_DATA', ['queResList', queResList.value])
      return {
        correctPercent: ((_stuSumScore * 100) / _queSumScore).toFixed(2),
        submitObj
      }
    }
    const queryPaperInfo = () => {
      getQuestionList({ gradeGroupId, subjectId, catalogueId, lkId, lkcId, gradeId })
        .then((res) => {
          if (res.data.code === 0) {
            const result = res.data?.data?.data || []
            // 后端处理不了二维数组,协助处理
            result.map((element) => {
              element.answer = Object.values(element.answer)
              element.answerOptionList = Object.values(element.answerOptionList)
            })
            paperInfo.value = result
            store.commit('taskPaper/SET_QUSTION_LIST', result)
            initQuestionsMap()
            entryTime = new Date().getTime()
            const timer = setInterval(() => {
              if (loadingProgress.value >= 100) {
                clearInterval(timer)
                return false
              }
              loadingProgress.value += 1
            }, 10)
            showWrongPage.value = false
          } else {
            store.commit('taskPaper/SET_QUSTION_LIST', [])
            res.data?.message && nativeToast(res.data.message)
            loadingProgress.value = 100
            showWrongPage.value = true
          }
        })
        .catch((err) => {
          console.log(err)
          store.commit('taskPaper/SET_QUSTION_LIST', [])
          showWrongPage.value = true
          loadingProgress.value = 100
        })
    }
    const handlePagerChange = (data) => {
      data?.queId && Object.assign(answerMap, { [data.queId]: data.data })
    }
    const configPaper = () => {
      if (window['TalqsInteraction']) {
        paperConfiged.value = true
        window['TalqsInteraction'].onChange = (data) => {
          handlePagerChange(data)
        }
      } else {
        const timer = setTimeout(() => {
          configPaper()
          clearTimeout(timer)
        }, 50)
      }
    }
    // 下一题
    const handleNext = () => {
      currentIndex.value =
        currentIndex.value === paperInfo.value.length - 1 ? 0 : currentIndex.value + 1
    }
    // 上一题
    const handlePrev = () => {
      if (currentIndex.value === 0) {
        return nativeToast('没有上一题啦')
      }
      currentIndex.value--
      scrollTop()
    }
    // 跳转到某个题
    const handleTargetTile = (index) => {
      answerSheetVisible.value = false
      currentIndex.value = index
      scrollTop()
    }
    // 回到顶部
    const scrollTop = () => {
      swipWrap.value.scrollTop = 0
    }
    // 校验是否每道题都填写了答案
    const verifyRequired = () => {
      let blankArr = [] // 用户组装未填写的题号
      let unAnsweredIndexsMap = {}
      Object.keys(questionsMap).forEach((item) => {
        // 可交互的题完全没做答或者部分没做答均算作未做答
        if (
          (!answerMap[item] && questionsMap[item].isDecidable === 1) ||
          answerMap?.[item]?.some((item) => item === '')
        ) {
          !blankArr.includes(questionsMap[item]?.index) && blankArr.push(questionsMap[item]?.index)
          unAnsweredIndexsMap[questionsMap[item]?.index] = true
        }
      })
      unAnsweredNum.value = blankArr.length
      return { blankArr, unAnsweredIndexsMap }
    }
    // 查看解析
    const handleShowAnswerAnalysis = () => {
      showAnswerAnalysis.value = true
      $xesLog.track('itembank_test_explain_click', { page_name, event_type: 'click' }, () => {})
    }

    const getResultData = () => {
      const judgeRes = (Object.keys(questionsMap || {}) || [])
        .filter((item) => questionsMap[item].isDecidable === 1)
        .map((item) => {
          let tile = questionsMap[item].queData
          let answerData = {
            queId: tile.queId,
            rigAnswer: tile.answer,
            type: tile.logicQuesTypeId,
            gradeGroupId: tile.gradeGroupId,
            subjectId: tile.subjectId,
            stuAnswer: answerMap[item] || ''
          }
          return window['judge'](answerData, store.getters.talqsInteractionConfig, {
            halfRight: 'false',
            content: false
          })
        })
      return makeResult(judgeRes)
    }
    const validHasUnAnswer = (from) => {
      if (answerSheetVisible.value) {
        answerSheetVisible.value = false
      }
      const logId = `itembank_test_submit_click${from === 'current' ? '' : '_card'}`
      $xesLog.track(logId, { page_name, event_type: 'click' }, () => {})
      let unAnsweredLen = verifyRequired()?.blankArr?.length || 0
      if (unAnsweredLen && from === 'current') {
        Object.assign(confirmInfo, {
          title: '题目还未完成,确认继续提交？',
          detail: '未完成的题目将被判定为回答错误',
          cancelText: '返回作答',
          confirmText: '确认提交',
          doClose: () => {
            $xesLog.track(
              'itembank_test_popup_click',
              { page_name, source_location: 'continue', event_type: 'click' },
              () => {}
            )
            showAnswerSheet(true)
          },
          doConfirm: () => {
            $xesLog.track(
              'itembank_test_popup_click',
              { page_name, source_location: 'submit', event_type: 'click' },
              () => {}
            )
            handleSubmit()
          }
        })
        confirmVisible.value = true
        return
      }
      handleSubmit()
    }
    // 提交
    const handleSubmit = () => {
      if (submitFlag.value) {
        return false
      }
      submitFlag.value = true
      let { correctPercent, submitObj } = getResultData()
      let tmpAnswer = []
      Object.keys(submitObj).forEach((item) => item && tmpAnswer.push(submitObj[item]))
      let submitData: {
        ans_duration: number
        score: number
        answer: any[]
        user_task_uuid?: string
        parent_task_uuid?: string
      } = {
        ans_duration: Math.round((new Date().getTime() - entryTime) / 1000), // 作答时长(秒)
        score: Number(correctPercent || 0), // 正确率
        answer: tmpAnswer
      }

      // 提交答案
      saveAnswer(submitData)
        .then((res) => {
          submitFlag.value = false
          if (res.data.code === 0) {
            store.commit('taskPaper/SET_DATA', ['submitQestionMap', submitObj])
            store.commit('taskPaper/SET_DATA', ['correctPercent', correctPercent])
            showAnswerReport.value = true
            document.title = '练习报告'
            doClose()
          } else {
            console.log(res.data.message)
          }
        })
        .catch((err) => {
          submitFlag.value = false
        })
    }

    const doRetry = () => {
      loadingAnimation()
      queryPaperInfo()
      // 重新答题 清空已作答答案并关闭答题结果
      Object.keys(answerMap).forEach((item) => {
        window['TalqsInteraction'].removeData(item)
      })
      answerMap = {}
      store.commit('taskPaper/SET_DATA', ['answerMap', {}])
      currentIndex.value = 0
      showAnswerReport.value = false
      showButton.value = false
      retryNum.value = retryNum.value + 1
    }
    // 显示答题卡
    const showAnswerSheet = (notClick) => {
      if (confirmVisible.value) {
        doClose()
      }
      if (!notClick) {
        $xesLog.track(
          'itembank_test_answer_sheet_click',
          { page_name, event_type: 'click' },
          () => ''
        )
      }

      let { unAnsweredIndexsMap } = verifyRequired()
      queResList.value = queResList.value.map((item, index) => {
        return { ...item, unAnswered: !!unAnsweredIndexsMap[index] }
      })
      nextTick(() => (answerSheetVisible.value = true))
    }

    const loadingAnimation = () => {
      loadingProgress.value = 0
      const target = Math.floor(Math.random() * (95 - 85)) + 85
      const timer = setInterval(() => {
        if (loadingProgress.value >= target) {
          clearInterval(timer)
          return false
        }
        loadingProgress.value = loadingProgress.value + 1
      }, 100)
    }

    const closeAnalysis = () => {
      showAnswerAnalysis.value = false
    }

    loadingAnimation()

    onMounted(() => {
      configPaper()
      queryPaperInfo()
      document.title = lkName as string
      nextTick(() => {
        // 在线答题pv埋点
        $xesLog.view(
          'itembank_test_pv',
          { page_name, source_location: 'item_bank', biz_name: 'int_lear', event_type: 'pv' },
          () => console.log('周周练刷题pv埋点')
        )
      })
    })
    onUnmounted(() => {
      try {
        window['TalqsInteraction']?.hideKeyboard()
      } catch (err) {
        console.log(err)
      }
    })
    return {
      actionBarInfo,
      showAnswerAnalysis,
      closeAnalysis,
      paperConfiged,
      paperInfo,
      questionList,
      currentIndex,
      swipeBox,
      swipWrap,
      confirmVisible,
      confirmInfo,
      pageLoading,
      showWrongPage,
      goBack,
      handleNext,
      handlePrev,
      handleTargetTile,
      validHasUnAnswer,
      queryPaperInfo,
      scrollTop,
      showAnswerReport,
      doRetry,
      showAnswerSheet,
      answerSheetVisible,
      queResList,
      unAnsweredNum,
      loadingProgress,
      handleShowAnswerAnalysis,
      submitQestionMap,
      showButton,
      retryNum
    }
  }
}
